import { useEffect } from "react";
import { useUpdateFlagsContext } from "@flash-tecnologia/feature-flags";
import { useSession } from "@hooks/use-session";

export const useUpdateFeatureFlagsContext = () => {
  const { userId, companyId, economicGroupId } = useSession();
  const updateContext = useUpdateFlagsContext();

  useEffect(() => {
    if (userId) {
      updateContext(userId, {
        economicGroupId,
        companyId,
        employeeId: userId,
      });
    }
  }, [userId, companyId, economicGroupId, updateContext]);
};
